import { getClient } from 'api'
import { AxiosInstance } from 'axios'

export enum PremiumRequestStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}

type PremiumCallResult = {
  isError: boolean
  data?: any // Axios response data
}

class PremiumCustomerStore {
  private apolloClient: AxiosInstance
  public premiumCallRequestStatus: PremiumRequestStatus | null = null

  constructor() {
    this.apolloClient = getClient('apollo')
  }

  setPremiumCallRequestStatus = (status: PremiumRequestStatus | null) => {
    this.premiumCallRequestStatus = status
  }

  getIsPremiumCallAccepted = async (
    advertisementId: string | null,
    traversalId: string | null
  ): Promise<PremiumCallResult> => {
    try {
      const response = await this.apolloClient.get(
        `/premium-call/${advertisementId}/${traversalId}`
      )
      this.setPremiumCallRequestStatus(PremiumRequestStatus.SUCCESS)
      return { isError: false, data: response.data }
    } catch (error) {
      this.setPremiumCallRequestStatus(PremiumRequestStatus.ERROR)
      return { isError: true }
    }
  }
}

export default PremiumCustomerStore
